const defaults = {
  fontFamily: '"Quicksand", sans-serif',
  fontWeight: 400
}

export default defaults
